<div class="notification">
  <div class="notification__message">
    <mat-icon>info</mat-icon>
    <p>A new app version is available, click reload page to update</p>
  </div>
  <div class="notification__actions">
    <button mat-raised-button color="primary" (click)="reloadPage()">Reload page</button>
    <button mat-button color="primary" (click)="close()">Close</button>
  </div>
</div>
